// extracted by mini-css-extract-plugin
export default {"canvasNavigation":"CanvasNavigation_canvasNavigation__IUmFH","active":"CanvasNavigation_active__z16ss"};